import { AnalyticsQueueEvent, analyticsQueueStore } from '~/modules/analytics/analyticsQueueStore';
import { handleException } from '~/modules/utilities/error_utilities';
import { AnalyticsTarget } from './analyticsTarget';
import { DataCloudEventType } from './datacloudEventTypes/datacloudEventType';
import { DataCloudEventTypeFactory } from './datacloudEventTypes/datacloudEventTypeFactory';
import { AnalyticsEvent } from '~/modules/services/analyticsService';

export class DataCloudAnalyticsTarget implements AnalyticsTarget {
    postEvent(event: AnalyticsEvent): Promise<unknown> {
        if (event.skipDataCloud) {
            return Promise.resolve();
        }
        const eventType = DataCloudEventTypeFactory.getEventType(event);
        if (eventType) {
            const analyticsEvent: AnalyticsQueueEvent = { target: this, event: event, eventType };
            analyticsQueueStore.sendAnalyticsEvent(analyticsEvent);
        }
        return Promise.resolve();
    }

    sendAnalyticsEvent(analyticsEvent: AnalyticsQueueEvent): void {
        const eventType = analyticsEvent.eventType;
        if (eventType && eventType instanceof DataCloudEventType) {
            try {
                const eventData = eventType.getBody(analyticsEvent.event);

                if ((window as any).SalesforceInteractions?.sendEvent) {
                    (window as any).SalesforceInteractions.sendEvent(eventData);
                }
            } catch (error) {
                handleException(error, 'datacloudAnalyticsTarget.sendAnalyticsEvent', { level: 'warn' });
            }
        }
    }
}
